import authentication from "@irati/auth";
import { get } from "lodash";
import GenericErrorCodes from "../../errorCodes/Generic";
var alwaysIgnore = [GenericErrorCodes.PBERRForbiddenInvalidToken, GenericErrorCodes.PBERRConflict];
export default function shouldSendCallback(data) {
    if (authentication.isInternal()) {
        // internal admins keep using direct urls and triggering 404s, just ignore all from internal admin
        return false;
    }
    var sentryIgnoreError = get(data, "extra.error.config.sentryIgnoreError", undefined);
    var sentryIgnoreAllErrors = get(data, "extra.error.config.sentryIgnoreAllErrors", false);
    if (sentryIgnoreAllErrors) {
        return false;
    }
    var code = getErrorCode(data);
    if (Array.isArray(sentryIgnoreError)) {
        if (sentryIgnoreError.indexOf(code) > -1) {
            return false;
        }
    }
    if (alwaysIgnore.indexOf(code) > -1) {
        return false;
    }
    return true;
}
function getErrorCode(data) {
    var apiCode = get(data, "extra.error.response.code");
    var graphCode = get(data, "extra.error.response.errors[0].errorCode");
    return apiCode || graphCode;
}
